import { isAppControl } from "@newsenec/auth-provider";

const predefinedCookies = {
    hubspot: false,
    facebook: false,
    "bing-ads": false,
    linkedin: false,
    outbrain: false,
    adform: false,
    hotjar: true,
    googleMaps: true,
    "google-analytics": true,
    stackadapt: false,
    "google-ads": false,
    "google-floodlight": false,
    "google-optimize": false,
    youtube: false,
    "google-tag-manager": true,
    "google-recaptcha": true,
    cloudflare: true,
};

function setCookie(name: string, value: string, expirationDays: number) {
    const date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);

    const expirationDate = date.toUTCString();

    document.cookie = `${name}=${value || ""}; expires=${expirationDate}; path=/; SameSite=Lax`;
}

function pushToGtm(appName: string) {
    window.dataLayer.push({ event: "loadgtm-" + appName });
}

export function overwriteKlaroConfigForControl() {
    if (isAppControl()) {
        setCookie("klaro", encodeURI(JSON.stringify(predefinedCookies)), 30);
        Object.entries(predefinedCookies).forEach(([key, value]) => {
            if (value) {
                pushToGtm(key);
            }
        });
    }
}
